// import React from "react";
// import { Link } from "react-router-dom";
// import Bgimg from '../../../assets/images/about-hero.png';

// const Innerpage = () => {
//     return (
//         <div
//             className="inner-page-hero"
//             style={{ backgroundImage: `url(${Bgimg})` }}
//         >
//             <div className="container">
//                 <div className="hero-heading-title">
//                     <h2>Fournder's Message</h2>
//                 </div>
//                 {/* <ul className="bradcrumb">
//                     <li>
//                         <Link to="/">Home</Link>
//                     </li>
//                     <li>
//                         <Link to="#">Page </Link>
//                     </li>
//                     <li>
//                         <Link to="#">About Us </Link>
//                     </li>
//                 </ul> */}
//             </div>
//         </div>

//     )
// }
// export default Innerpage;

import React from 'react';
import { Link } from 'react-router-dom';
import Headertwo from "../../Global/Headertwo";
import Bgimg from '../../../assets/images/about-hero.png';
import Ctalogo from '../../../assets/images/neha.jpg';
import Star from '../../../assets/images/star-bottom.png';
import Footer from "../../Global/Footer";
import BackToTop from '../../Global/BackToTop';

const FoundersMessage = () => {
    return (
        <>
            <Headertwo />

            <div className="founders-message-page">
                {/* Hero Section */}
                <div
                    className="inner-page-hero"
                    style={{ backgroundImage: `url(${Bgimg})` }}
                >
                    <div className="container">
                        <div className="hero-heading-title">
                            <h2>Founder's Message</h2>
                        </div>
                        {/* Breadcrumb (optional) */}
                    </div>
                </div>

                {/* Main Content Section */}
                <section className="cta-one" style={{ paddingTop: 24 }}>
                    <div className="container">
                        <div className="text-center mb-4" style={{ marginTop: 32 }}>
                            <h1 style={{
                                fontWeight: 500,
                                fontSize: '2.5rem',
                                marginBottom: 0,
                                paddingBottom: 0,
                                lineHeight: "40px"
                            }}>
                                A dream to serve - born out of a personal passion.
                            </h1>
                            <img
                                src={Star}
                                className="img-fluid w-60-mobile w-50"
                                style={{
                                    marginTop: 0,
                                    paddingTop: 0,
                                    marginBottom: "2em",
                                    maxWidth: "60%"
                                }}
                                alt="Decorative Star"
                            />
                        </div>
                        <div className="container px-3 px-sm-4 px-md-5 px-lg-5">
                            <div className="row justify-content-center align-items-start mt-4">
                                
                                {/* Text Section */}
                                <div className="col-12 col-md-8 col-lg-7 mb-4 mb-lg-0">
                                <div
                                    className="mt-4 mt-md-0" id='justify-content'
                                    style={{ fontSize: 18, lineHeight: 1.7 }}
                                >
                                    <p className="mb-3"><span style={{ fontWeight: 600, fontSize: 22 }}>Hello friends,</span></p>
                                    <p style={{ textAlign: "justify"}}>
                                    Welcome to our family. The idea for The NRI Advisors was born out of a personal passion – a passion to serve the needs of many NRIs like you...
                                    </p>
                                    <p style={{ textAlign: "justify"}}>
                                    That’s why The NRI Advisors was established. We believe NRIs around the world deserve a reliable, ethical, and efficient way to handle their affairs in India—without the stress, uncertainty, or endless travel.
                                    </p>
                                    <p style={{ textAlign: "justify"}}>
                                    We are committed to bringing peace of mind to NRIs by offering expert solutions they can trust. We built a handpicked team of professionals who understand not just the technicalities of Indian systems, but also the emotional realities of living abroad. Our approach blends professionalism with a deeply human touch. We don’t just offer services—we build relationships rooted in transparency, care, and accountability.
                                    </p>
                                    <p style={{ textAlign: "justify"}}>
                                    Today, The NRI Advisors proudly serves clients across the U.S., Canada, the Middle East, Europe, and beyond. We strive to be a dependable partner who stands in for you, acts on your behalf, and looks out for your best interests. No matter where you live, you can count on us to handle things back home as if they were our own. Because for us, every NRI we serve is family.
                                    </p>
                                    <p style={{ fontWeight: 600, marginTop: 32, marginBottom: 0 }}>
                                    Warm regards,<br />
                                    Neha Aggarwal<br />
                                    <span style={{ fontWeight: 400 }}>Founder, The NRI Advisors</span>
                                    </p>
                                </div>
                                </div>

                                {/* Image Section */}
                                <div className="col-10 col-md-4 col-lg-3 d-flex justify-content-center">
                                <img
                                    src={Ctalogo}
                                    alt="Neha Aggarwal"
                                    style={{
                                    width: '100%',
                                    maxWidth: 320,
                                    height: 'auto',
                                    aspectRatio: '4 / 5',
                                    objectFit: 'cover',
                                    borderRadius: 4,
                                    boxShadow: '0 2px 16px rgba(0,0,0,0.08)',
                                    }}
                                />
                                </div>
                            </div>
                            </div>

                    </div>
                </section>

            </div>

            <Footer />
            <BackToTop />
        </>
    );
};

export default FoundersMessage;
